import axios from 'axios';
import {
    GET_UNIT_BY_ID_FAILURE,
    GET_UNIT_BY_ID_REQUEST,
    GET_UNIT_BY_ID_SUCCESS,
    GET_APPOINTMENTS_BY_ID_FAILURE,
    GET_APPOINTMENTS_BY_ID_REQUEST,
    GET_APPOINTMENTS_BY_ID_SUCCESS,
    RESET_APPOINTMENTS
} from '../constants/unitById.constant';

const getUnitByIdRequest = () => {
    return {
        type: GET_UNIT_BY_ID_REQUEST,
    };
};

const getUnitByIdSuccess = (unitByIdData: string) => {
    return {
        type: GET_UNIT_BY_ID_SUCCESS,
        payload: unitByIdData,
    };
};

const getUnitByIdFailure = (errorData: string) => {
    return {
        type: GET_UNIT_BY_ID_FAILURE,
        payload: errorData,
    };
};

// Appointments
const getAppointmentsByIdRequest = () => {
    return {
        type: GET_APPOINTMENTS_BY_ID_REQUEST
    };
};

const getAppointmentsByIdSuccess = (unitByIdData: string) => {

    return {
        type: GET_APPOINTMENTS_BY_ID_SUCCESS,
        payload: unitByIdData,
    };
};

const getAppointmentsByIdFailure = (errorData: string) => {
    return {
        type: GET_APPOINTMENTS_BY_ID_FAILURE,
        payload: errorData,
    };
};

export const resetAppointments = () => {
    return {
        type: RESET_APPOINTMENTS,
    };
}

export const getUnitById = (id: string | undefined, useInternalApi?: boolean) => {
    return (dispatch: (arg: { type: string; payload?: string; }) => void) => {

        dispatch(getUnitByIdRequest());
        axios
            .get(`/admin/units/${id}`, {
                headers: {
                    ...(useInternalApi ? { 'x-internal-api': 'true' } : {}),
                },
            })
            .then((response) => dispatch(getUnitByIdSuccess(response.data)))
            .catch((err) => dispatch(getUnitByIdFailure(err)));
    };
};

// Appointments
export const getAppointmentByUnitId = (id: string | undefined, useInternalApi?: boolean) => {
    return (dispatch: (arg: { type: string; payload?: string; }) => void) => {
        dispatch(getAppointmentsByIdRequest());
        axios
            .get(`/admin/appointments/unit/${id}`, {
                headers: {
                    ...(useInternalApi ? { 'x-internal-api': 'true' } : {}),
                }
            })
            .then((response) => dispatch(getAppointmentsByIdSuccess(response.data)))
            .catch((err) => dispatch(getAppointmentsByIdFailure(err)));
    };
};
